"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookMessageTypeEnum = void 0;
var WebhookMessageTypeEnum;
(function (WebhookMessageTypeEnum) {
    WebhookMessageTypeEnum["KYB"] = "KYB";
    WebhookMessageTypeEnum["TRANSACTION"] = "TRANSACTION";
    WebhookMessageTypeEnum["DEPOSIT"] = "DEPOSIT";
    WebhookMessageTypeEnum["TRANSFER"] = "TRANSFER";
})(WebhookMessageTypeEnum || (exports.WebhookMessageTypeEnum = WebhookMessageTypeEnum = {}));
